export const SensorsWidget = (props) => {
    let results = [];
    if(props.data !== undefined && props.data.length > 1){
        props.data.forEach((element, index) => {
            results.push(
                <p style={{fontWeight: 'bold', color: '#659767', margin: '5px 0 0 0', fontSize: 'small'}} key={index}>{element.deviceName}</p>
            )
        })
        
        return(
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center'}}>
                {results}
                <p style={{fontWeight: 'bold', color: '#659767', margin: '5px 0 0 0', fontSize: 'small'}}>Últimos Setores Ligados - Total: {props.data[props.data.length - 1].totalActive}</p>
                {/* <p style={{fontWeight: 'bold', color: '#659767', margin: '5px 0 0 0', fontSize: 'small'}}>Total Setores Ativos: {props.data[props.data.length - 1].totalActive}</p> */}
            </div>
        )
    } else {
        return(
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center'}}>
                <p style={{fontWeight: 'bold', color: '#659767', margin: '5px 0 0 0', fontSize: 'small'}}>Nenhum Setor em Funcionamento</p>
            </div>
        )
    }
}